(function () {
    'use strict';

    angular
        .module('wsl.nounEnding')
        .provider('nounEndingHelper', nounEndingHelperProvider);


    /* @ngInject */
    function nounEndingHelperProvider() {
        this.$get = NounEndingHelper;

        function NounEndingHelper() {
            var service = {
                getNoun: getNoun
            };

            return service;

            ////////////////

            /**
             * Функция возвращает окончание для множественного числа слова на основании числа и массива окончаний
             * @param  iNumber Integer Число на основе которого нужно сформировать окончание
             * @param  aEndings Array Массив слов или окончаний для чисел (1, 2, 5), (кто? что?|кого? чего?| мн.ч)
             *         например ['яблоко', 'яблока', 'яблок']
             * @return String
             */
            function getNoun(iNumber, aEndings) {
                var sEnding, i;
                iNumber = iNumber % 100;
                if (iNumber >= 11 && iNumber <= 19) {
                    sEnding = aEndings[2];
                }
                else {
                    i = iNumber % 10;
                    switch (i) {
                        case (1):
                            sEnding = aEndings[0];
                            break;
                        case (2):
                        case (3):
                        case (4):
                            sEnding = aEndings[1];
                            break;
                        default:
                            sEnding = aEndings[2];
                    }
                }
                return sEnding;
            }
        }
    }
})();
